import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { changeSelectedMenuItemId, closeNavigationDrawer } from "../../../export/drawer";
import { StoreType } from "../../../ts/utils/types";
import NavDrawer from "../../components/drawer/ui";
import { MOBILE_BAR_HEIGHT } from "../../components/drawer/ui/mobile-nav-bar";
import { useEdgeBoxStyle } from "../../components/drawer/use-edge-height-style";
import PageLayout from "../../design/wilya-page-layout";
import { planner } from "./planner-ui";
import SchedulerTabs from "./scheduler-tabs";

const FullTimeMiniDrawer = () => {
  const dispatch = useDispatch();
  const boxStyle = useEdgeBoxStyle();
  const navigate = useNavigate();
  const ftSchedulerEnabled = useSelector(
    (state: StoreType) => state.user.userData.ftSchedulerEnabled
  );
  const ftSchedulerEnabledLocations = useSelector(
    (state: StoreType) => state.user.userData.ftSchedulerEnabledLocations || []
  );
  useEffect(() => {
    if (ftSchedulerEnabled && ftSchedulerEnabledLocations.length > 0) {
      // To select admin config menu item
      dispatch(changeSelectedMenuItemId(1));
      dispatch(closeNavigationDrawer());
    } else {
      navigate("/");
    }
  }, [dispatch, navigate, ftSchedulerEnabled, ftSchedulerEnabledLocations]);
	return (
		<Box
			sx={{
        ...boxStyle,
				display: "flex",
				backgroundColor: planner.canvas,
				width: "100%",
				position: "fixed",
				// Below 900px the phone top bar occupies the first 56px.
				top: { xs: `${MOBILE_BAR_HEIGHT}px`, md: 0 },
				left: 0,
				right: 0,
				bottom: 0,
			}}
		>
			<CssBaseline />
			<NavDrawer keepSettingOpen={false} />
      <PageLayout>
        <Box sx={{
          flexGrow: 1,
          overflowY: "hidden",
          borderRadius: "15px",
        }}>
          <SchedulerTabs />
        </Box>
      </PageLayout>
		</Box>
	);
};

export default FullTimeMiniDrawer;
